// Module
var code = "<div class=\"amt-footer amt-wider-footer\" ng-transclude> </div>";
// Exports
module.exports = code;